import { Link, useSearchParams } from "react-router-dom";
import { MailCheck } from "lucide-react";

export default function CheckEmail() {
  const [params] = useSearchParams();
  const email = params.get("email") || "your inbox";

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center px-4">
      <div className="w-full max-w-[400px] text-center">
        <div className="w-14 h-14 bg-purple-50 dark:bg-purple-900/30 rounded-full flex items-center justify-center mx-auto mb-6">
          <MailCheck className="w-6 h-6 text-purple-600 dark:text-purple-400" />
        </div>
        <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">Check your email</h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed mb-1">
          We sent a confirmation link to
        </p>
        <p className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-4">{email}</p>
        <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed mb-3">
          Click the link in that email to confirm your account — you'll be signed in automatically.
        </p>
        <p className="text-xs text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg px-3 py-2 mb-7">
          Don't see it? Check your <strong>Spam</strong> or <strong>Promotions</strong> folder — it can take a minute to arrive.
        </p>
        <Link
          to="/login"
          className="inline-block bg-purple-600 hover:bg-purple-700 text-white text-sm font-medium px-6 py-2.5 rounded-md transition"
        >
          Go to Sign In
        </Link>
      </div>
    </div>
  );
}